import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Box, TablePagination } from '@mui/material';
import { TableTitle } from '../general/TableFunctions';
import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { useGetCompaniesFilteredQuery } from './../../store/api/backoffice/backofficeApi'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { TableBackOfficeRow } from './table/TableRow';
import { changeFilters } from '../../store/slices/backoffice/backofficeCompaniesSlice';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import IconButton from '@mui/material/IconButton';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const rows = [
  {companyId: 12023762, companyName: 'Transol', companyTenant: '1022aslhdçasldk1230120', drivers: 10, BDT1: {connection: 'lakhslkdahslkjdhak', connectionUp: true, show: false},  BDT2: {connection: 'lakhslkdahslkjdhak', connectionUp: false}},
  {companyId: 12023762, companyName: 'EVA', companyTenant: '1022aslhdçasldk1230120', drivers: 10, BDT1: {connection: 'lakhslkdahslkjdhak', connectionUp: true, show: false},  BDT2: {connection: 'lakhslkdahslkjdhak', connectionUp: false}},
  {companyId: 12023762, companyName: 'Frota Azul Algarve', companyTenant: '1022aslhdçasldk1230120', drivers: 10, BDT1: {connection: 'lakhslkdahslkjdhak', connectionUp: true},  BDT2: {connection: 'lakhslkdahslkjdhak', connectionUp: true}},
  {companyId: 12023762, companyName: 'Barraqueiro Oeste', companyTenant: '1022aslhdçasldk1230120', drivers: 10, BDT1: {connection: 'lakhslkdahslkjdhak', connectionUp: true},  BDT2: {connection: 'lakhslkdahslkjdhak', connectionUp: true}},
  {companyId: 12023762, companyName: 'Cityrama', companyTenant: '1022aslhdçasldk1230120', drivers: 10, BDT1: {connection: 'lakhslkdahslkjdhak', connectionUp: true},  BDT2: {connection: 'lakhslkdahslkjdhak', connectionUp: true}},
  {companyId: 12023762, companyName: 'Maia Transportes', companyTenant: '1022aslhdçasldk1230120', drivers: 10, BDT1: {connection: 'lakhslkdahslkjdhak', connectionUp: true},  BDT2: {connection: 'lakhslkdahslkjdhak', connectionUp: true}},
];

function BackOfficeCompaniesTable() {
  const dispatch = useDispatch<AppDispatch>();
  const backofficeCompanies = useSelector((state: RootState) => state.backofficeCompanies)
  const { data: backofficeCompaniesRawData, isLoading, refetch } = useGetCompaniesFilteredQuery(backofficeCompanies.filters)
  let [show, setShow] = useState(false)
  let [snackBar, setSnackbar] = useState(false)
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  
  const handleShow = (item: any) => {
    if(show){
      setShow(false)
      setSnackbar(false)
      navigator.clipboard.writeText(item.BDT1.connection);
    } else {
      setShow(true)
      setSnackbar(true)
    } 
  }

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const allRowIds = backofficeCompaniesRawData?.itemList.map((item: any) => item.companyDatabaseId) || [];
      setSelectedRows(allRowIds);
    }
    setSelectAll(!selectAll);
  };

  const handleRowSelect = (companyId: number) => {
    setSelectedRows(prev => {
      if (prev.includes(companyId)) {
        return prev.filter(id => id !== companyId);
      } else {
        return [...prev, companyId];
      }
    });
  };

  const isRowSelected = (companyId: number) => {
    return selectedRows.includes(companyId);
  };

  const handleSort = (column: string) => {
    const newAscending = backofficeCompanies.filters.orderByColumn === column 
      ? !backofficeCompanies.filters.ascending 
      : true;

    dispatch(changeFilters({
      ...backofficeCompanies.filters,
      orderByColumn: column,
      ascending: newAscending
    }));
    refetch();
  };

  const getSortIcon = (column: string) => {
    if (backofficeCompanies.filters.orderByColumn !== column) return null;
    return backofficeCompanies.filters.ascending ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />;
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    dispatch(changeFilters({
      ...backofficeCompanies.filters,
      currentPage: newPage + 1
    }));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(changeFilters({
      ...backofficeCompanies.filters,
      pageSize: parseInt(event.target.value, 10),
      currentPage: 1
    }));
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={backofficeCompaniesRawData?.totalResults || 0}
          rowsPerPage={backofficeCompanies.filters.pageSize}
          page={backofficeCompanies.filters.currentPage - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Itens por página"
          labelDisplayedRows={({ from, to, count }) => {
            const totalPages = Math.ceil(count / backofficeCompanies.filters.pageSize);
            return `${from}-${to} de ${count} (Página ${backofficeCompanies.filters.currentPage} de ${totalPages})`;
          }}
        />
      </Box>
      <TableContainer>
        <Table stickyHeader sx={{ borderBlockEnd: '1px solid rgba(224, 224, 224, 1)' }} aria-label="simple table" id="table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ paddingBlock: '8px' }}>
                <Checkbox 
                  {...label} 
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell sx={{ paddingBlock: '8px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort('CompanyName')}>
                  <TableTitle title1="Nome da Empresa" />
                  <IconButton size="small" >
                    {getSortIcon('CompanyName')}
                  </IconButton>
                </Box>
              </TableCell>
              <TableCell sx={{ paddingBlock: '8px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort('CompanyDatabaseId')} >
                  <TableTitle title1="ID" />
                  <IconButton size="small" >
                    {getSortIcon('CompanyDatabaseId')}
                  </IconButton>
                </Box>
              </TableCell>
              {/* <TableCell sx={{ paddingBlock: '8px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <TableTitle title1="Tenant" />
                  <IconButton size="small" onClick={() => handleSort('Tenants')}>
                    {getSortIcon('Tenants')}
                  </IconButton>
                </Box>
              </TableCell>
              <TableCell sx={{ paddingBlock: '8px' }}>
                <TableTitle title1="BD T1" />
              </TableCell>
              <TableCell sx={{ paddingBlock: '8px' }}>
                <TableTitle title1="BD T2" />
              </TableCell> */}
              <TableCell sx={{ paddingBlock: '8px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <TableTitle title1="Motoristas" />
                  <IconButton size="small" onClick={() => handleSort('DriversCount')}>
                    {getSortIcon('DriversCount')}
                  </IconButton>
                </Box>
              </TableCell>
              <TableCell sx={{ paddingBlock: '8px' }}>
                <TableTitle title1="" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="tableBody">
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            ) : backofficeCompaniesRawData ? (
              backofficeCompaniesRawData.itemList.map((item: any, index: any) => (
                <TableBackOfficeRow 
                  key={item?.companyName} 
                  index={index} 
                  item={item} 
                  isSelected={isRowSelected(item.companyDatabaseId)}
                  onSelect={() => handleRowSelect(item.companyDatabaseId)}
                />
              ))
            ) : ''}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default BackOfficeCompaniesTable;